const translations = {
  es: {
    common: {
      loading: 'Cargando...',
      apply: 'Aplicar',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      create: 'Crear',
      export: 'Exportar',
      import: 'Importar',
      download: 'Descargar',
      search: 'Buscar',
      filter: 'Filtrar',
      clear: 'Limpiar',
      all: 'Todas',
      noData: 'Sin datos',
      yes: 'Sí',
      no: 'No',
      close: 'Cerrar',
      select: 'Seleccionar',
      update: 'Actualizar',
      previous: 'Anterior',
      next: 'Siguiente',
      page: 'Página',
      of: 'de',
      showing: 'Mostrando',
      records: 'registros'
    },
    nav: {
      dashboard: 'Dashboard',
      capture: 'Captura',
      catalogs: 'Catálogos',
      acciones: 'Acciones',
      sites: 'Sitios',
      users: 'Usuarios',
      reports: 'Reportes',
      about: 'Acerca de',
      logout: 'Cerrar Sesión'
    },
    login: {
      title: 'Iniciar Sesión',
      username: 'Usuario',
      password: 'Contraseña',
      loginButton: 'Entrar',
      error: 'Error de autenticación'
    },
    forgotPassword: {
      title: 'Olvidé mi Contraseña',
      subtitle: 'Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña',
      emailLabel: 'Correo Electrónico',
      emailPlaceholder: 'tu-email@ejemplo.com',
      emailRequired: 'El correo electrónico es requerido',
      sendLink: 'Enviar Enlace de Recuperación',
      sending: 'Enviando...',
      emailSent: 'Correo enviado exitosamente',
      emailSentMessage: 'Si el correo existe en nuestro sistema, recibirás un enlace para restablecer tu contraseña.',
      checkEmail: '¡Revisa tu Correo!',
      checkSpam: 'Si no lo encuentras, revisa tu carpeta de correo no deseado (SPAM).',
      backToLogin: 'Volver al inicio de sesión',
      error: 'Error al enviar el correo',
      note: 'Nota',
      noteMessage: 'El enlace de recuperación expirará en 60 minutos por seguridad.'
    },
    resetPassword: {
      title: 'Restablecer Contraseña',
      subtitle: 'Ingresa tu nueva contraseña',
      emailLabel: 'Correo Electrónico',
      newPasswordLabel: 'Nueva Contraseña',
      newPasswordPlaceholder: 'Ingresa tu nueva contraseña',
      confirmPasswordLabel: 'Confirmar Contraseña',
      confirmPasswordPlaceholder: 'Confirma tu nueva contraseña',
      passwordHint: 'Mínimo 6 caracteres',
      resetButton: 'Restablecer Contraseña',
      resetting: 'Restableciendo...',
      allFieldsRequired: 'Todos los campos son requeridos',
      passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
      passwordMismatch: 'Las contraseñas no coinciden',
      success: 'Contraseña restablecida exitosamente',
      successTitle: '¡Contraseña Actualizada!',
      successMessage: 'Tu contraseña ha sido restablecida exitosamente. Redirigiendo al inicio de sesión...',
      goToLogin: 'Ir al inicio de sesión',
      backToLogin: 'Volver al inicio de sesión',
      error: 'Error al restablecer la contraseña',
      invalidLink: 'Enlace inválido o expirado'
    },
    dashboard: {
      title: 'Dashboard Analítico',
      subtitle: 'Indicadores, gráficos y filtros.',
      filters: {
        dateFrom: 'Desde',
        dateTo: 'Hasta',
        lines: 'Líneas',
        shifts: 'Turnos',
        productContains: 'Producto contiene',
        defectContains: 'Defecto contiene'
      },
      kpis: {
        totalDefects: 'Total Defectos',
        totalRecords: 'Registros',
        uniqueProducts: 'Productos Únicos',
        uniqueLines: 'Líneas',
        fpy: 'FPY',
        cpk: 'Cpk',
        sigma: 'Nivel Sigma',
        context: 'Prod: {produced} | Def: {defects}'
      },
      charts: {
        dailyTrend: 'Tendencia Diaria',
        paretoType: 'Pareto por Tipo',
        stackedLineType: 'Barras apiladas: Línea vs Tipo',
        mix100: 'Mix 100% por Línea',
        additionalParetos: 'Paretos Adicionales',
        paretoLine: 'Pareto por Línea',
        paretoShift: 'Pareto por Turno',
        paretoProduct: 'Pareto por Producto',
        paretoLineDefects: 'Pareto de Defectos (Línea específica)',
        treemap: 'Treemap Producto → Tipo',
        quantity: 'Cantidad',
        movingAverage: 'Media móvil',
        target: 'Objetivo',
        projection: 'Proyección (3 días)',
        cumulative: 'Acumulado %',
        percentOfTotal: '% del total',
        top30: 'Top 30',
        viewAll: 'Ver Todos Prod.',
        viewPercent: 'Ver %',
        viewQuantities: 'Ver Cantidades',
        line: 'Línea',
        list: 'lista',
        chart: 'gráfico',
        topN: 'Top N',
        exportPNG: 'Export PNG',
        allProducts: 'Todos'
      },
      permissions: {
        noAccess: 'No tienes permisos para ver el dashboard (se requiere analyst o admin).'
      }
    },
    capture: {
      title: 'Captura de Defectos',
      subtitle: 'Formulario para capturar defectos y tabla editable con paginación.',
      formTitle: 'Formulario de Captura',
      tableTitle: 'Defectos Registrados',
      loading: 'Cargando...',
      loadingCatalogs: 'Cargando catálogos...',
      form: {
        date: 'Fecha',
        line: 'Línea',
        shift: 'Turno',
        product: 'Producto',
        productPlaceholder: 'Código de producto',
        defectType: 'Tipo de Defecto',
        quantity: 'Cantidad',
        notes: 'Observaciones',
        selectLine: 'Seleccionar línea...',
        selectShift: 'Seleccionar turno...',
        selectDefectType: 'Seleccionar tipo...',
        saveButton: 'Guardar Defecto',
        saving: 'Guardando...'
      },
      table: {
        date: 'Fecha',
        line: 'Línea',
        shift: 'Turno',
        product: 'Producto',
        defectType: 'Tipo Defecto',
        quantity: 'Cantidad',
        notes: 'Observaciones',
        actions: 'Acciones',
        noData: 'No hay defectos registrados',
        edit: 'Editar',
        delete: 'Eliminar',
        save: 'Guardar',
        cancel: 'Cancelar',
        importCSV: 'Importar CSV',
        exportCSV: 'Exportar CSV'
      },
      filters: {
        from: 'Desde',
        to: 'Hasta',
        line: 'Línea',
        shift: 'Turno',
        product: 'Producto',
        defectType: 'Defecto',
        notes: 'Notas',
        searchLine: 'Buscar línea',
        searchShift: 'Buscar turno',
        searchProduct: 'Código',
        searchDefectType: 'Tipo',
        searchNotes: 'Buscar texto'
      },
      pagination: {
        showing: 'Mostrando',
        of: 'de',
        page: 'Página',
        previous: '◀ Anterior',
        next: 'Siguiente ▶'
      },
      messages: {
        success: 'Defecto guardado',
        updateSuccess: 'Actualizado',
        deleteSuccess: 'Eliminado',
        error: 'Error al guardar',
        completeFields: 'Completa todos los campos obligatorios.',
        confirmDelete: '¿Eliminar este registro?',
        sessionExpired: 'Sesión expirada. Redirigiendo al login...',
        noPermissions: 'No tienes permisos para acceder a esta información.',
        connectionError: 'Error de conexión. Verifica que el servidor esté funcionando.',
        loadError: 'Error de carga',
        retry: 'Reintentar',
        goToLogin: 'Ir al Login',
        imported: 'Importados',
        failed: 'Fallidos'
      }
    },
    catalogs: {
      title: 'Catálogos',
      subtitle: 'Gestiona líneas, turnos, productos y tipos de defecto.',
      tabs: {
        lines: 'Líneas',
        shifts: 'Turnos',
        products: 'Productos',
        downtimeCodes: 'Códigos T muerto',
        defectTypes: 'Tipos de Defecto'
      },
      form: {
        code: 'Código',
        name: 'Nombre',
        description: 'Descripción'
      },
      buttons: {
        refresh: 'Refrescar',
        add: 'Agregar',
        save: 'Guardar',
        cancel: 'Cancelar',
        edit: 'Editar',
        delete: 'Eliminar'
      },
      table: {
        code: 'Código',
        name: 'Nombre',
        actions: 'Acciones'
      },
      messages: {
        createSuccess: 'Creado exitosamente',
        updateSuccess: 'Actualizado exitosamente',
        deleteSuccess: 'Eliminado exitosamente',
        error: 'Error en la operación',
        confirmDelete: '¿Eliminar este elemento?',
        deleteConfirm: 'Eliminar registro?',
        noData: 'No hay registros en este catálogo'
      }
    },
    users: {
      title: 'Usuarios',
      subtitle: 'Gestión de cuentas',
      adminOnly: '(solo administradores)',
      createTitle: 'Crear usuario',
      listTitle: 'Lista de usuarios',
      loading: 'Cargando...',
      filters: {
        search: 'Buscar',
        searchPlaceholder: 'Nombre, email o sitio',
        role: 'Rol',
        allRoles: 'Todos los roles',
        status: 'Estado',
        allStatuses: 'Todos los estados',
        active: 'Activos',
        inactive: 'Inactivos',
        site: 'Sitio',
        allSites: 'Todos los sitios',
        results: '{shown} de {total} usuarios',
        clear: 'Limpiar filtros',
        noResults: 'No hay usuarios que coincidan con los filtros'
      },
      form: {
        username: 'Nombre',
        email: 'Email (Login)',
        emailPlaceholder: 'usuario@empresa.com',
        password: 'Contraseña',
        newPassword: 'Nueva contraseña (opcional)',
        role: 'Rol',
        active: 'Activo',
        created: 'Creado',
        site: 'Sitio',
        selectSite: 'Seleccionar sitio',
        namePlaceholder: 'Nombre completo'
      },
      roles: {
        admin: 'Administrador',
        analyst: 'Analista',
        operator: 'Operador',
        supervisor_conversion: 'Supervisor Conversión'
      },
      table: {
        id: 'ID',
        username: 'Nombre',
        email: 'Email',
        role: 'Rol',
        site: 'Sitio',
        active: 'Activo',
        created: 'Creado',
        actions: 'Acciones',
        yes: 'Sí',
        no: 'No'
      },
      buttons: {
        create: 'Crear',
        creating: 'Creando...',
        edit: 'Editar',
        save: 'Guardar',
        cancel: 'Cancelar',
        activate: 'Activar',
        deactivate: 'Desactivar',
        delete: 'Eliminar',
        actions: 'Acciones'
      },
      messages: {
        createSuccess: 'Usuario creado',
        updateSuccess: 'Usuario actualizado',
        deleteSuccess: 'Usuario eliminado',
        error: 'Error en la operación',
        requiredFields: 'Nombre, email y contraseña son obligatorios',
        confirmDelete: '¿Eliminar este usuario?',
        adminOnlyError: 'Solo administradores pueden gestionar usuarios',
        createError: 'No se pudo crear',
        updateError: 'No se pudo actualizar',
        deleteError: 'No se pudo eliminar',
        statusError: 'No se pudo cambiar estado',
        cannotEditMaster: 'No puedes editar usuarios con rol admin_master',
        cannotModifyMaster: 'No puedes modificar usuarios con rol admin_master',
        cannotDeleteMaster: 'No puedes eliminar usuarios con rol admin_master'
      },
      tooltips: {
        active: 'Activo',
        inactive: 'Inactivo',
        edit: 'Editar',
        activate: 'Activar',
        deactivate: 'Desactivar',
        delete: 'Eliminar',
        actions: 'Acciones'
      }
    },
    sites: {
      title: 'Gestión de Sitios',
      subtitle: 'Administra las plantas de producción (solo Admin Master)',
      createTitle: 'Crear Sitio',
      listTitle: 'Lista de Sitios',
      loading: 'Cargando sitios...',
      form: {
        code: 'Código',
        name: 'Nombre',
        city: 'Ciudad',
        state: 'Estado',
        country: 'País',
        active: 'Activo',
        namePlaceholder: 'Ej: Rio Bravo Plant',
        cityPlaceholder: 'Ej: Rio Bravo'
      },
      table: {
        code: 'Código',
        name: 'Nombre',
        city: 'Ciudad',
        state: 'Estado',
        country: 'País',
        active: 'Activo',
        actions: 'Acciones'
      },
      buttons: {
        create: 'Crear Sitio',
        creating: 'Creando...',
        edit: 'Editar',
        save: 'Guardar',
        cancel: 'Cancelar',
        activate: 'Activar',
        deactivate: 'Desactivar',
        delete: 'Eliminar'
      },
      messages: {
        createSuccess: 'Sitio creado exitosamente',
        updateSuccess: 'Sitio actualizado exitosamente',
        deleteSuccess: 'Sitio eliminado exitosamente',
        statusSuccess: 'Estado actualizado',
        createError: 'Error al crear sitio',
        updateError: 'Error al actualizar sitio',
        deleteError: 'Error al eliminar sitio',
        statusError: 'Error al cambiar estado',
        requiredFields: 'Código y nombre son obligatorios',
        confirmDelete: '¿Eliminar este sitio?',
        noSites: 'No hay sitios registrados',
        adminMasterOnly: 'Solo Admin Master puede gestionar sitios'
      },
      tooltips: {
        active: 'Sitio activo',
        inactive: 'Sitio inactivo',
        edit: 'Editar sitio',
        activate: 'Activar sitio',
        deactivate: 'Desactivar sitio',
        delete: 'Eliminar sitio',
        actions: 'Acciones'
      }
    },
    reporter: {
      title: 'Reportes Semanales Multi-Línea',
      subtitle: '(Imprimible)',
      dateFrom: 'Fecha inicio',
      dateTo: 'Fecha fin',
      selectLines: 'Líneas (selección múltiple)',
      emptyAll: 'Vacío = todas',
      selectAll: 'Todas',
      clear: 'Limpiar',
      generate: 'Generar reportes',
      generating: 'Cargando...',
      downloadPDF: 'Descargar PDF',
      summary: 'Resumen Línea',
      range: 'Rango',
      defectsByDay: 'Defectos por día',
      summaryBox: 'Resumen',
      totalDefects: 'Total defectos',
      uniqueProducts: 'Productos únicos',
      uniqueLines: 'Líneas únicas',
      topDefects: 'Top defectos',
      noData: 'Sin datos',
      noDataFound: 'No se encontraron datos para el rango seleccionado.'
    },
    acciones: {
      title: 'Gestión de Problemas y Acciones',
      tabs: {
        problems: 'Problemas',
        eightd: 'Reportes 8D',
        actions: 'Acciones'
      },
      problemForm: {
        title: 'Registrar Problema',
        line: 'Línea',
        selectLine: 'Seleccionar línea...',
        defectType: 'Tipo de Defecto',
        selectDefectType: 'Seleccionar tipo...',
        product: 'Producto',
        selectProduct: 'Seleccionar producto...',
        detectedAt: 'Fecha de Detección',
        status: 'Estado',
        description: 'Descripción'
      },
      problemList: {
        title: 'Lista de Problemas',
        id: 'ID',
        line: 'Línea',
        defectType: 'Tipo Defecto',
        product: 'Producto',
        detectedAt: 'Detectado',
        status: 'Estado',
        actions: 'Acciones'
      },
      eightdForm: {
        title: 'Crear Reporte 8D',
        problem: 'Problema',
        selectProblem: 'Seleccionar problema...',
        code: 'Código 8D',
        autoGenerated: 'Generado automáticamente',
        willBeGenerated: 'Se generará automáticamente: 8D-YYYY-###',
        owner: 'Responsable',
        selectOwner: 'Seleccionar responsable...',
        status: 'Estado',
        startedAt: 'Fecha de Inicio'
      },
      eightdList: {
        title: 'Lista de Reportes 8D',
        code: 'Código',
        problem: 'Problema',
        owner: 'Responsable',
        status: 'Estado',
        startedAt: 'Iniciado',
        actions: 'Acciones'
      },
      actionForm: {
        title: 'Crear Acción',
        eightd: 'Reporte 8D',
        selectEightD: 'Seleccionar 8D...',
        type: 'Tipo',
        description: 'Descripción',
        owner: 'Responsable',
        selectOwner: 'Seleccionar responsable...',
        dueAt: 'Fecha Límite',
        status: 'Estado'
      },
      actionList: {
        title: 'Lista de Acciones',
        id: 'ID',
        eightd: '8D',
        type: 'Tipo',
        description: 'Descripción',
        owner: 'Responsable',
        dueAt: 'Fecha Límite',
        status: 'Estado',
        actions: 'Acciones'
      },
      status: {
        open: 'Abierto',
        under_analysis: 'En Análisis',
        containment: 'Contención',
        corrective: 'Correctivo',
        monitoring: 'Monitoreo',
        closed: 'Cerrado',
        draft: 'Borrador',
        in_progress: 'En Progreso',
        implemented: 'Implementado',
        verified: 'Verificado',
        done: 'Completado',
        cancelled: 'Cancelado'
      },
      actionTypes: {
        containment: 'Contención',
        corrective: 'Correctiva',
        preventive: 'Preventiva'
      },
      buttons: {
        create: 'Crear',
        update: 'Actualizar',
        cancel: 'Cancelar',
        edit: 'Editar',
        delete: 'Eliminar',
        add: 'Agregar',
        remove: 'Quitar',
        actions: 'Acciones',
        viewDetail: 'Ver Detalle'
      },
      messages: {
        errorSaving: 'Error al guardar',
        confirmDelete: '¿Está seguro de eliminar este registro?',
        noProblems: 'No hay problemas registrados',
        noEightD: 'No hay reportes 8D registrados',
        noActions: 'No hay acciones registradas',
        noPermissions: 'No tienes permisos para acceder a esta página. Solo usuarios Analyst y Admin pueden gestionar Acciones 8D.',
        requiredFields: 'Por favor complete los campos requeridos: Línea y Tipo de Defecto',
        requiredFieldsAction: 'Por favor complete los campos requeridos: Reporte 8D y Descripción',
        requiredFields8D: 'Por favor seleccione un Problema (el código se generará automáticamente)',
        duplicateProblem: 'Ya existe un problema con esta combinación de Línea, Tipo de Defecto, Producto y Fecha de Detección. Por favor edite el problema existente o cambie la fecha.',
        duplicateWarning: '¡Advertencia! Ya existe un problema similar',
        duplicateWarningDetail: 'Existe un problema con la misma Línea, Tipo de Defecto, Producto y Fecha',
        error: 'Error al guardar los datos',
        selectEightD: 'Seleccione un reporte 8D',
        requiredFieldsTeam: 'Por favor complete: Nombre y Rol',
        requiredFieldsWhy: 'Por favor complete: Categoría de Causa Raíz y Declaración',
        maxWhyLevels: 'Máximo 5 niveles de Why permitidos',
        checkingPermissions: 'Verificando permisos...'
      },
      teamMembers: {
        title: 'Equipo 8D',
        selectReport: 'Seleccionar Reporte 8D...',
        add: 'Agregar Miembro',
        edit: 'Editar Miembro',
        name: 'Nombre',
        role: 'Rol',
        email: 'Email',
        noMembers: 'No hay miembros en el equipo'
      },
      fiveWhys: {
        title: 'Análisis 5 Whys',
        selectReport: 'Seleccionar Reporte 8D...',
        add: 'Crear Análisis 5 Whys',
        edit: 'Editar Análisis 5 Whys',
        category: 'Categoría',
        rootStatement: 'Declaración de Causa Raíz',
        rootStatementPlaceholder: 'Describa la causa raíz identificada...',
        validated: 'Validado',
        whyLevels: 'Niveles de Por Qué',
        level: 'Nivel',
        question: 'Pregunta',
        answer: 'Respuesta',
        addLevel: 'Agregar Nivel',
        noTrees: 'No hay análisis 5 Whys registrados'
      },
      actionsSection: {
        containment: 'Acciones de Contención',
        corrective: 'Acciones Correctivas',
        preventive: 'Acciones Preventivas',
        containmentAction: 'Acción de Contención',
        correctiveAction: 'Acción Correctiva',
        preventiveAction: 'Acción Preventiva',
        addAction: 'Agregar',
        newAction: 'Nueva',
        editAction: 'Editar',
        description: 'Descripción',
        owner: 'Responsable',
        selectUser: 'Seleccionar usuario',
        dueDate: 'Fecha límite',
        status: 'Estado',
        noActions: 'No hay {type} registradas',
        verified: 'Verificada',
        verifiedBy: 'Verificado por:',
        evidence: 'Evidencias:',
        evidenceItem: 'Evidencia',
        verify: 'Verificar',
        unverify: 'Desverificar',
        statusDraft: 'Borrador',
        statusInProgress: 'En progreso',
        statusDone: 'Completada',
        statusVerified: 'Verificada'
      }
    },
    d6verification: {
      title: 'D6 - Verificación de Efectividad',
      problem: 'Problema:',
      loading: 'Cargando mediciones...',
      noProblemAssociated: '⚠️ Este reporte 8D no tiene un problema asociado. Por favor, asocia un problema primero.',
      measurements: {
        title: '📊 Mediciones PRE y POST',
        newPost: '+ Nueva Medición POST',
        postForm: {
          title: 'Nueva Medición POST',
          description: 'Se calculará desde la última medición hasta la fecha seleccionada',
          endDate: 'Fecha Final del Análisis',
          compareTo: 'Comparar con',
          selectReference: 'Seleccionar medición de referencia',
          preRate: 'PRE - Tasa:',
          postRate: 'POST {index} - Tasa:',
          notes: 'Notas (Opcional)',
          placeholder: 'Ej: Medición después de implementar acciones correctivas...',
          create: 'Crear Medición POST',
          cancel: 'Cancelar'
        },
        noPreWarning: '⚠️ No se encontró una medición PRE. Esta se crea automáticamente al crear el problema. Si el problema ya existe, puedes crear una medición PRE manualmente.',
        pre: {
          title: '📉 PRE (Antes)',
          goodProduction: 'Producción Buena',
          defects: 'Defectos',
          defectRate: 'Tasa de Defectos',
          notes: 'Notas'
        },
        post: {
          title: '📈 POST {index} (Después)',
          goodProduction: 'Producción Buena',
          defects: 'Defectos',
          defectRate: 'Tasa de Defectos',
          improvementVs: 'Mejora vs {type}',
          improved: '✓ Mejoró',
          worsened: '✗ Empeoró'
        }
      },
      charts: {
        comparison: 'Comparación de Tasas',
        defectRateLabel: 'Tasa de Defectos: PRE vs POST',
        trend: 'Tendencia en el Tiempo',
        evolution: 'Evolución de la Tasa de Defectos'
      },
      interpretation: {
        title: '💡 Interpretación',
        tip: '💡 Tip: Puedes crear múltiples mediciones POST para monitorear la efectividad de las acciones en el tiempo.'
      },
      statistics: {
        title: '📊 Análisis Estadístico',
        show: 'Ver Análisis Estadístico',
        hide: 'Ocultar',
        noWindows: 'No hay ventanas de análisis creadas',
        createFromPre: 'Crear Análisis Estadístico desde PRE',
        window: {
          runTests: 'Ejecutar Tests Estadísticos'
        },
        descriptive: {
          pre: {
            title: '📉 PRE (Baseline)',
            mean: 'Media:',
            stdDev: 'Desv. Estándar:',
            sampleSize: 'Tamaño muestra:'
          },
          post: {
            title: '📈 POST (Después)',
            mean: 'Media:',
            stdDev: 'Desv. Estándar:',
            sampleSize: 'Tamaño muestra:',
            improvement: 'Mejora:'
          }
        },
        tests: {
          title: '🔬 Pruebas Estadísticas',
          pValue: 'P-value:',
          significant: '✓ Significativo',
          notSignificant: '○ No Significativo',
          tStatistic: 't-statistic',
          degreesOfFreedom: 'Grados libertad',
          differenceMeans: 'Dif. medias',
          fStatistic: 'F-statistic',
          dfBetween: 'DF Between',
          dfWithin: 'DF Within',
          power: 'Poder Estadístico'
        },
        conclusion: {
          title: '🎯 Conclusión Estadística',
          significantTests: 'pruebas resultaron estadísticamente significativas',
          of: 'de'
        },
        info: {
          title: 'ℹ️ Acerca de las Pruebas Estadísticas',
          tTest: 'T-Test: Compara las medias de dos grupos independientes (PRE vs POST). p-value < 0.05 indica diferencia significativa.',
          zTest: 'Z-Test: Similar al t-test pero para muestras grandes (n ≥ 30). Más robusto con grandes volúmenes de datos.',
          anova: 'ANOVA: Análisis de varianza que detecta si existen diferencias significativas entre grupos.',
          power: 'Poder Estadístico: Capacidad de la prueba para detectar diferencias reales. Se recomienda ≥ 80%.',
          alpha: 'α = 0.05: Nivel de significancia (5% de probabilidad de error Tipo I)'
        }
      },
      messages: {
        loadError: 'Error al cargar mediciones',
        noProblem: 'No hay problema asociado',
        selectEndDate: 'Selecciona una fecha final para el análisis POST',
        postCreated: 'Medición POST creada exitosamente',
        postCreateError: 'Error al crear medición POST',
        windowCreated: 'Ventana de análisis creada',
        windowCreateError: 'Error al crear ventana de análisis',
        analysisCompleted: 'Análisis estadístico completado',
        analysisError: 'Error al actualizar análisis',
        recalculated: 'Medición recalculada',
        recalculateError: 'Error al recalcular',
        deleted: 'Medición eliminada',
        deleteError: 'Error al eliminar',
        confirmDelete: '¿Eliminar esta medición?'
      }
    },
    about: {
      title: 'Acerca de',
      description: 'Sistema de Gestión de Defectos de Calidad v1.0'
    }
  },
  en: {
    common: {
      loading: 'Loading...',
      apply: 'Apply',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      export: 'Export',
      import: 'Import',
      download: 'Download',
      search: 'Search',
      filter: 'Filter',
      clear: 'Clear',
      all: 'All',
      noData: 'No data',
      yes: 'Yes',
      no: 'No',
      close: 'Close',
      select: 'Select',
      update: 'Update',
      previous: 'Previous',
      next: 'Next',
      page: 'Page',
      of: 'of',
      showing: 'Showing',
      records: 'records'
    },
    nav: {
      dashboard: 'Dashboard',
      capture: 'Capture',
      catalogs: 'Catalogs',
      acciones: 'Actions',
      sites: 'Sites',
      users: 'Users',
      reports: 'Reports',
      about: 'About',
      logout: 'Logout'
    },
    login: {
      title: 'Login',
      username: 'Username',
      password: 'Password',
      loginButton: 'Sign In',
      error: 'Authentication error'
    },
    forgotPassword: {
      title: 'Forgot Password',
      subtitle: 'Enter your email and we will send you a link to reset your password',
      emailLabel: 'Email Address',
      emailPlaceholder: 'your-email@example.com',
      emailRequired: 'Email address is required',
      sendLink: 'Send Recovery Link',
      sending: 'Sending...',
      emailSent: 'Email sent successfully',
      emailSentMessage: 'If the email exists in our system, you will receive a link to reset your password.',
      checkEmail: 'Check Your Email!',
      checkSpam: 'If you don\'t find it, check your spam folder.',
      backToLogin: 'Back to login',
      error: 'Error sending email',
      note: 'Note',
      noteMessage: 'The recovery link will expire in 60 minutes for security.'
    },
    resetPassword: {
      title: 'Reset Password',
      subtitle: 'Enter your new password',
      emailLabel: 'Email Address',
      newPasswordLabel: 'New Password',
      newPasswordPlaceholder: 'Enter your new password',
      confirmPasswordLabel: 'Confirm Password',
      confirmPasswordPlaceholder: 'Confirm your new password',
      passwordHint: 'Minimum 6 characters',
      resetButton: 'Reset Password',
      resetting: 'Resetting...',
      allFieldsRequired: 'All fields are required',
      passwordTooShort: 'Password must be at least 6 characters',
      passwordMismatch: 'Passwords do not match',
      success: 'Password reset successfully',
      successTitle: 'Password Updated!',
      successMessage: 'Your password has been reset successfully. Redirecting to login...',
      goToLogin: 'Go to login',
      backToLogin: 'Back to login',
      error: 'Error resetting password',
      invalidLink: 'Invalid or expired link'
    },
    dashboard: {
      title: 'Analytics Dashboard',
      subtitle: 'Indicators, charts and filters.',
      filters: {
        dateFrom: 'From',
        dateTo: 'To',
        lines: 'Lines',
        shifts: 'Shifts',
        productContains: 'Product contains',
        defectContains: 'Defect contains'
      },
      kpis: {
        totalDefects: 'Total Defects',
        totalRecords: 'Records',
        uniqueProducts: 'Unique Products',
        uniqueLines: 'Lines',
        fpy: 'FPY',
        cpk: 'Cpk',
        sigma: 'Sigma Level',
        context: 'Prod: {produced} | Def: {defects}'
      },
      charts: {
        dailyTrend: 'Daily Trend',
        paretoType: 'Pareto by Type',
        stackedLineType: 'Stacked Bars: Line vs Type',
        mix100: 'Mix 100% by Line',
        additionalParetos: 'Additional Paretos',
        paretoLine: 'Pareto by Line',
        paretoShift: 'Pareto by Shift',
        paretoProduct: 'Pareto by Product',
        paretoLineDefects: 'Defect Pareto (Specific Line)',
        treemap: 'Treemap Product → Type',
        quantity: 'Quantity',
        movingAverage: 'Moving average',
        target: 'Target',
        projection: 'Projection (3 days)',
        cumulative: 'Cumulative %',
        percentOfTotal: '% of total',
        top30: 'Top 30',
        viewAll: 'View All Products',
        viewPercent: 'View %',
        viewQuantities: 'View Quantities',
        line: 'Line',
        list: 'list',
        chart: 'chart',
        topN: 'Top N',
        exportPNG: 'Export PNG',
        allProducts: 'All'
      },
      permissions: {
        noAccess: 'You do not have permissions to view the dashboard (analyst or admin required).'
      }
    },
    capture: {
      title: 'Defect Capture',
      subtitle: 'Form to capture defects and editable table with pagination.',
      formTitle: 'Capture Form',
      tableTitle: 'Registered Defects',
      loading: 'Loading...',
      loadingCatalogs: 'Loading catalogs...',
      form: {
        date: 'Date',
        line: 'Line',
        shift: 'Shift',
        product: 'Product',
        productPlaceholder: 'Product code',
        defectType: 'Defect Type',
        quantity: 'Quantity',
        notes: 'Notes',
        selectLine: 'Select line...',
        selectShift: 'Select shift...',
        selectDefectType: 'Select type...',
        saveButton: 'Save Defect',
        saving: 'Saving...'
      },
      table: {
        date: 'Date',
        line: 'Line',
        shift: 'Shift',
        product: 'Product',
        defectType: 'Defect Type',
        quantity: 'Quantity',
        notes: 'Notes',
        actions: 'Actions',
        noData: 'No defects registered',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        importCSV: 'Import CSV',
        exportCSV: 'Export CSV'
      },
      filters: {
        from: 'From',
        to: 'To',
        line: 'Line',
        shift: 'Shift',
        product: 'Product',
        defectType: 'Defect',
        notes: 'Notes',
        searchLine: 'Search line',
        searchShift: 'Search shift',
        searchProduct: 'Code',
        searchDefectType: 'Type',
        searchNotes: 'Search text'
      },
      pagination: {
        showing: 'Showing',
        of: 'of',
        page: 'Page',
        previous: '◀ Previous',
        next: 'Next ▶'
      },
      messages: {
        success: 'Defect saved',
        updateSuccess: 'Updated',
        deleteSuccess: 'Deleted',
        error: 'Error saving',
        completeFields: 'Complete all required fields.',
        confirmDelete: 'Delete this record?',
        sessionExpired: 'Session expired. Redirecting to login...',
        noPermissions: 'You do not have permissions to access this information.',
        connectionError: 'Connection error. Verify that the server is running.',
        loadError: 'Load error',
        retry: 'Retry',
        goToLogin: 'Go to Login',
        imported: 'Imported',
        failed: 'Failed'
      }
    },
    catalogs: {
      title: 'Catalogs',
      subtitle: 'Manage lines, shifts, products and defect types.',
      tabs: {
        lines: 'Lines',
        shifts: 'Shifts',
        products: 'Products',
        downtimeCodes: 'Downtime Codes',
        defectTypes: 'Defect Types'
      },
      form: {
        code: 'Code',
        name: 'Name',
        description: 'Description'
      },
      buttons: {
        refresh: 'Refresh',
        add: 'Add',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete'
      },
      table: {
        code: 'Code',
        name: 'Name',
        actions: 'Actions'
      },
      messages: {
        createSuccess: 'Created successfully',
        updateSuccess: 'Updated successfully',
        deleteSuccess: 'Deleted successfully',
        error: 'Operation error',
        confirmDelete: 'Delete this item?',
        deleteConfirm: 'Delete record?',
        noData: 'No records in this catalog'
      }
    },
    users: {
      title: 'Users',
      subtitle: 'Account management',
      adminOnly: '(administrators only)',
      createTitle: 'Create user',
      listTitle: 'User list',
      loading: 'Loading...',
      filters: {
        search: 'Search',
        searchPlaceholder: 'Name, email or site',
        role: 'Role',
        allRoles: 'All roles',
        status: 'Status',
        allStatuses: 'All statuses',
        active: 'Active',
        inactive: 'Inactive',
        site: 'Site',
        allSites: 'All sites',
        results: '{shown} of {total} users',
        clear: 'Clear filters',
        noResults: 'No users match the filters'
      },
      form: {
        username: 'Name',
        email: 'Email (Login)',
        emailPlaceholder: 'user@company.com',
        password: 'Password',
        newPassword: 'New password (optional)',
        role: 'Role',
        active: 'Active',
        created: 'Created',
        site: 'Site',
        selectSite: 'Select site',
        namePlaceholder: 'Full name'
      },
      roles: {
        admin: 'Administrator',
        analyst: 'Analyst',
        operator: 'Operator',
        supervisor_conversion: 'Conversion Supervisor'
      },
      table: {
        id: 'ID',
        username: 'Name',
        email: 'Email',
        role: 'Role',
        site: 'Site',
        active: 'Active',
        created: 'Created',
        actions: 'Actions',
        yes: 'Yes',
        no: 'No'
      },
      buttons: {
        create: 'Create',
        creating: 'Creating...',
        edit: 'Edit',
        save: 'Save',
        cancel: 'Cancel',
        activate: 'Activate',
        deactivate: 'Deactivate',
        delete: 'Delete',
        actions: 'Actions'
      },
      messages: {
        createSuccess: 'User created',
        updateSuccess: 'User updated',
        deleteSuccess: 'User deleted',
        error: 'Operation error',
        requiredFields: 'Name, email and password are required',
        confirmDelete: 'Delete this user?',
        adminOnlyError: 'Only administrators can manage users',
        createError: 'Could not create',
        updateError: 'Could not update',
        deleteError: 'Could not delete',
        statusError: 'Could not change status',
        cannotEditMaster: 'You cannot edit users with admin_master role',
        cannotModifyMaster: 'You cannot modify users with admin_master role',
        cannotDeleteMaster: 'You cannot delete users with admin_master role'
      },
      tooltips: {
        active: 'Active',
        inactive: 'Inactive',
        edit: 'Edit',
        activate: 'Activate',
        deactivate: 'Deactivate',
        delete: 'Delete',
        actions: 'Actions'
      }
    },
    sites: {
      title: 'Site Management',
      subtitle: 'Manage production plants (Admin Master only)',
      createTitle: 'Create Site',
      listTitle: 'Site List',
      loading: 'Loading sites...',
      form: {
        code: 'Code',
        name: 'Name',
        city: 'City',
        state: 'State',
        country: 'Country',
        active: 'Active',
        namePlaceholder: 'Ex: Rio Bravo Plant',
        cityPlaceholder: 'Ex: Rio Bravo'
      },
      table: {
        code: 'Code',
        name: 'Name',
        city: 'City',
        state: 'State',
        country: 'Country',
        active: 'Active',
        actions: 'Actions'
      },
      buttons: {
        create: 'Create Site',
        creating: 'Creating...',
        edit: 'Edit',
        save: 'Save',
        cancel: 'Cancel',
        activate: 'Activate',
        deactivate: 'Deactivate',
        delete: 'Delete'
      },
      messages: {
        createSuccess: 'Site created successfully',
        updateSuccess: 'Site updated successfully',
        deleteSuccess: 'Site deleted successfully',
        statusSuccess: 'Status updated',
        createError: 'Error creating site',
        updateError: 'Error updating site',
        deleteError: 'Error deleting site',
        statusError: 'Error changing status',
        requiredFields: 'Code and name are required',
        confirmDelete: 'Delete this site?',
        noSites: 'No sites registered',
        adminMasterOnly: 'Only Admin Master can manage sites'
      },
      tooltips: {
        active: 'Active site',
        inactive: 'Inactive site',
        edit: 'Edit site',
        activate: 'Activate site',
        deactivate: 'Deactivate site',
        delete: 'Delete site',
        actions: 'Actions'
      }
    },
    reporter: {
      title: 'Multi-Line Weekly Reports',
      subtitle: '(Printable)',
      dateFrom: 'Start date',
      dateTo: 'End date',
      selectLines: 'Lines (multiple selection)',
      emptyAll: 'Empty = all',
      selectAll: 'All',
      clear: 'Clear',
      generate: 'Generate reports',
      generating: 'Loading...',
      downloadPDF: 'Download PDF',
      summary: 'Line Summary',
      range: 'Range',
      defectsByDay: 'Defects by day',
      summaryBox: 'Summary',
      totalDefects: 'Total defects',
      uniqueProducts: 'Unique products',
      uniqueLines: 'Unique lines',
      topDefects: 'Top defects',
      noData: 'No data',
      noDataFound: 'No data found for the selected range.'
    },
    acciones: {
      title: 'Problem and Action Management',
      tabs: {
        problems: 'Problems',
        eightd: '8D Reports',
        actions: 'Actions'
      },
      problemForm: {
        title: 'Register Problem',
        line: 'Line',
        selectLine: 'Select line...',
        defectType: 'Defect Type',
        selectDefectType: 'Select type...',
        product: 'Product',
        selectProduct: 'Select product...',
        detectedAt: 'Detection Date',
        status: 'Status',
        description: 'Description'
      },
      problemList: {
        title: 'Problem List',
        id: 'ID',
        line: 'Line',
        defectType: 'Defect Type',
        product: 'Product',
        detectedAt: 'Detected',
        status: 'Status',
        actions: 'Actions'
      },
      eightdForm: {
        title: 'Create 8D Report',
        problem: 'Problem',
        selectProblem: 'Select problem...',
        code: '8D Code',
        autoGenerated: 'Auto-generated',
        willBeGenerated: 'Will be auto-generated: 8D-YYYY-###',
        owner: 'Owner',
        selectOwner: 'Select owner...',
        status: 'Status',
        startedAt: 'Start Date'
      },
      eightdList: {
        title: '8D Reports List',
        code: 'Code',
        problem: 'Problem',
        owner: 'Owner',
        status: 'Status',
        startedAt: 'Started',
        actions: 'Actions'
      },
      actionForm: {
        title: 'Create Action',
        eightd: '8D Report',
        selectEightD: 'Select 8D...',
        type: 'Type',
        description: 'Description',
        owner: 'Owner',
        selectOwner: 'Select owner...',
        dueAt: 'Due Date',
        status: 'Status'
      },
      actionList: {
        title: 'Action List',
        id: 'ID',
        eightd: '8D',
        type: 'Type',
        description: 'Description',
        owner: 'Owner',
        dueAt: 'Due Date',
        status: 'Status',
        actions: 'Actions'
      },
      status: {
        open: 'Open',
        under_analysis: 'Under Analysis',
        containment: 'Containment',
        corrective: 'Corrective',
        monitoring: 'Monitoring',
        closed: 'Closed',
        draft: 'Draft',
        in_progress: 'In Progress',
        implemented: 'Implemented',
        verified: 'Verified',
        done: 'Done',
        cancelled: 'Cancelled'
      },
      actionTypes: {
        containment: 'Containment',
        corrective: 'Corrective',
        preventive: 'Preventive'
      },
      buttons: {
        create: 'Create',
        update: 'Update',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        add: 'Add',
        remove: 'Remove',
        actions: 'Actions',
        viewDetail: 'View Detail'
      },
      messages: {
        errorSaving: 'Error saving',
        confirmDelete: 'Are you sure you want to delete this record?',
        noProblems: 'No problems registered',
        noEightD: 'No 8D reports registered',
        noActions: 'No actions registered',
        noPermissions: 'You do not have permissions to access this page. Only Analyst and Admin users can manage 8D Actions.',
        requiredFields: 'Please complete the required fields: Line and Defect Type',
        requiredFieldsAction: 'Please complete the required fields: 8D Report and Description',
        requiredFields8D: 'Please select a Problem (code will be auto-generated)',
        duplicateProblem: 'A problem with this combination of Line, Defect Type, Product and Detection Date already exists. Please edit the existing problem or change the date.',
        duplicateWarning: 'Warning! A similar problem already exists',
        duplicateWarningDetail: 'A problem exists with the same Line, Defect Type, Product and Date',
        error: 'Error saving data',
        selectEightD: 'Select an 8D report',
        requiredFieldsTeam: 'Please complete: Name and Role',
        requiredFieldsWhy: 'Please complete: Root Cause Category and Statement',
        maxWhyLevels: 'Maximum 5 Why levels allowed',
        checkingPermissions: 'Checking permissions...'
      },
      teamMembers: {
        title: '8D Team',
        selectReport: 'Select 8D Report...',
        add: 'Add Member',
        edit: 'Edit Member',
        name: 'Name',
        role: 'Role',
        email: 'Email',
        noMembers: 'No team members'
      },
      fiveWhys: {
        title: '5 Whys Analysis',
        selectReport: 'Select 8D Report...',
        add: 'Create 5 Whys Analysis',
        edit: 'Edit 5 Whys Analysis',
        category: 'Category',
        rootStatement: 'Root Cause Statement',
        rootStatementPlaceholder: 'Describe the identified root cause...',
        validated: 'Validated',
        whyLevels: 'Why Levels',
        level: 'Level',
        question: 'Question',
        answer: 'Answer',
        addLevel: 'Add Level',
        noTrees: 'No 5 Whys analysis registered'
      },
      actionsSection: {
        containment: 'Containment Actions',
        corrective: 'Corrective Actions',
        preventive: 'Preventive Actions',
        containmentAction: 'Containment Action',
        correctiveAction: 'Corrective Action',
        preventiveAction: 'Preventive Action',
        addAction: 'Add',
        newAction: 'New',
        editAction: 'Edit',
        description: 'Description',
        owner: 'Owner',
        selectUser: 'Select user',
        dueDate: 'Due date',
        status: 'Status',
        noActions: 'No {type} registered',
        verified: 'Verified',
        verifiedBy: 'Verified by:',
        evidence: 'Evidence:',
        evidenceItem: 'Evidence',
        verify: 'Verify',
        unverify: 'Unverify',
        statusDraft: 'Draft',
        statusInProgress: 'In progress',
        statusDone: 'Completed',
        statusVerified: 'Verified'
      }
    },
    d6verification: {
      title: 'D6 - Effectiveness Verification',
      problem: 'Problem:',
      loading: 'Loading measurements...',
      noProblemAssociated: '⚠️ This 8D report has no associated problem. Please associate a problem first.',
      measurements: {
        title: '📊 PRE and POST Measurements',
        newPost: '+ New POST Measurement',
        postForm: {
          title: 'New POST Measurement',
          description: 'It will be calculated from the last measurement until the selected date',
          endDate: 'Analysis End Date',
          compareTo: 'Compare to',
          selectReference: 'Select reference measurement',
          preRate: 'PRE - Rate:',
          postRate: 'POST {index} - Rate:',
          notes: 'Notes (Optional)',
          placeholder: 'Ex: Measurement after implementing corrective actions...',
          create: 'Create POST Measurement',
          cancel: 'Cancel'
        },
        noPreWarning: '⚠️ No PRE measurement found. This is created automatically when creating the problem. If the problem already exists, you can create a PRE measurement manually.',
        pre: {
          title: '📉 PRE (Before)',
          goodProduction: 'Good Production',
          defects: 'Defects',
          defectRate: 'Defect Rate',
          notes: 'Notes'
        },
        post: {
          title: '📈 POST {index} (After)',
          goodProduction: 'Good Production',
          defects: 'Defects',
          defectRate: 'Defect Rate',
          improvementVs: 'Improvement vs {type}',
          improved: '✓ Improved',
          worsened: '✗ Worsened'
        }
      },
      charts: {
        comparison: 'Rate Comparison',
        defectRateLabel: 'Defect Rate: PRE vs POST',
        trend: 'Trend Over Time',
        evolution: 'Defect Rate Evolution'
      },
      interpretation: {
        title: '💡 Interpretation',
        tip: '💡 Tip: You can create multiple POST measurements to monitor action effectiveness over time.'
      },
      statistics: {
        title: '📊 Statistical Analysis',
        show: 'View Statistical Analysis',
        hide: 'Hide',
        noWindows: 'No analysis windows created',
        createFromPre: 'Create Statistical Analysis from PRE',
        window: {
          runTests: 'Run Statistical Tests'
        },
        descriptive: {
          pre: {
            title: '📉 PRE (Baseline)',
            mean: 'Mean:',
            stdDev: 'Std. Dev.:',
            sampleSize: 'Sample size:'
          },
          post: {
            title: '📈 POST (After)',
            mean: 'Mean:',
            stdDev: 'Std. Dev.:',
            sampleSize: 'Sample size:',
            improvement: 'Improvement:'
          }
        },
        tests: {
          title: '🔬 Statistical Tests',
          pValue: 'P-value:',
          significant: '✓ Significant',
          notSignificant: '○ Not Significant',
          tStatistic: 't-statistic',
          degreesOfFreedom: 'Degrees of freedom',
          differenceMeans: 'Diff. means',
          fStatistic: 'F-statistic',
          dfBetween: 'DF Between',
          dfWithin: 'DF Within',
          power: 'Statistical Power'
        },
        conclusion: {
          title: '🎯 Statistical Conclusion',
          significantTests: 'tests were statistically significant',
          of: 'of'
        },
        info: {
          title: 'ℹ️ About Statistical Tests',
          tTest: 'T-Test: Compares means of two independent groups (PRE vs POST). p-value < 0.05 indicates significant difference.',
          zTest: 'Z-Test: Similar to t-test but for large samples (n ≥ 30). More robust with large data volumes.',
          anova: 'ANOVA: Analysis of variance that detects significant differences between groups.',
          power: 'Statistical Power: Ability of the test to detect real differences. ≥ 80% recommended.',
          alpha: 'α = 0.05: Significance level (5% probability of Type I error)'
        }
      },
      messages: {
        loadError: 'Error loading measurements',
        noProblem: 'No associated problem',
        selectEndDate: 'Select an end date for POST analysis',
        postCreated: 'POST measurement created successfully',
        postCreateError: 'Error creating POST measurement',
        windowCreated: 'Analysis window created',
        windowCreateError: 'Error creating analysis window',
        analysisCompleted: 'Statistical analysis completed',
        analysisError: 'Error updating analysis',
        recalculated: 'Measurement recalculated',
        recalculateError: 'Error recalculating',
        deleted: 'Measurement deleted',
        deleteError: 'Error deleting',
        confirmDelete: 'Delete this measurement?'
      }
    },
    about: {
      title: 'About',
      description: 'Quality Defect Management System v1.0'
    }
  }
};

export default translations;
